import { STORAGE_PREFIX } from 'config';
import { isObject, merge } from 'lodash';

export function storeItem<T = object>(
  key: string,
  value: T,
  shouldMerge = false
) {
  const fqdnKey = `${STORAGE_PREFIX}_${key}`;

  if (shouldMerge) {
    const oldValue = getStoredItem<T>(key);
    if (isObject(value) && isObject(oldValue)) {
      const newValue = merge(oldValue, value);
      window.localStorage.setItem(fqdnKey, JSON.stringify(newValue));
      return;
    }
  }
  window.localStorage.setItem(fqdnKey, JSON.stringify(value));
}

export function getStoredItem<T = string>(key: string): T | null {
  const fqdnKey = `${STORAGE_PREFIX}_${key}`;

  const item = window.localStorage.getItem(fqdnKey);

  if (!item) {
    return null;
  }

  try {
    return JSON.parse(item) as T;
  } catch (ex) {
    return item as unknown as T;
  }
}

export function removeStoredItem(key: string) {
  window.localStorage.removeItem(`${STORAGE_PREFIX}_${key}`);
}
